import angular from 'angular'

import { noop } from 'lodash-es'
import { zeroIfNaN } from '../../utils/bits'

import setCss from '../../utils/set-css'
import envRaw from '../../utils/env-raw'
import StrictObj from '../../utils/strict-obj'
import extractRawElm from '../../utils/extract-raw-elm'

import Template from './gallery-thumb-preview.component.ejs'

angular
  .module('ggs.gallery-thumb-preview')
  .component('ggsGalleryThumbPreview', {
    template: Template(StrictObj({
      LE: envRaw.liveEditMode
    })),
    controller: GalleryThumbPreviewComponent,
    bindings: {
      ggsPost: '<',
      ggsProperties: '<',
      ggsContentDoneCallback: '<',
      ggsContentFailCallback: '<'
    }
  })

function GalleryThumbPreviewComponent($log, $scope, $element, imgQueue) {

  const $ctrl = $scope.$ctrl = StrictObj(this)
  const sign = `galleryThumbPreview[id=${$ctrl.ggsPost.id}]`

  let thumbSize = null

  const thumbFit = true
    && !envRaw.liveEditMode
    && !$ctrl.ggsProperties.square_preview
    && !$ctrl.ggsProperties.normalize_preview

  const thumbRaw = true
    && $ctrl.ggsPost.preview.info.isSomeImage
    && $ctrl.ggsProperties.use_raw_images_as_thumbs

  const thumbElm = extractRawElm($element).firstElementChild

  $ctrl.thumbUrl = thumbRaw
    ? $ctrl.ggsPost.preview.file
    : $ctrl.ggsPost.preview.file_thumb

  $ctrl.thumbLoadCallbacks = {
    done: thumbLoadDoneCallback,
    fail: thumbLoadFailCallback
  }

  function calcContentWidth(showcaseHeight) {
    return zeroIfNaN((thumbSize.width / thumbSize.height) * showcaseHeight)
  }

  function calcContentHeight(showcaseWidth) {
    return zeroIfNaN((thumbSize.height / thumbSize.width) * showcaseWidth)
  }

  function applyShowcaseSize(psmSize) {
    const normThumbWidth = psmSize.showcaseWidth
    const normThumbHeight = Math.floor(zeroIfNaN(thumbSize.height / thumbSize.width * normThumbWidth))

    if (normThumbHeight < psmSize.showcaseHeight) {
      const overThumbWidth = zeroIfNaN(normThumbWidth / normThumbHeight * psmSize.showcaseHeight)
      const diffThumbWidth = psmSize.showcaseWidth - overThumbWidth
      const marginLeft = Math.ceil(diffThumbWidth / 2)
      setCss(thumbElm, 'width', 'auto')
      setCss(thumbElm, 'height', psmSize.showcaseHeight)
      setCss(thumbElm, 'marginTop', null)
      setCss(thumbElm, 'marginLeft', marginLeft)
    } else {
      const overThumbHeight = zeroIfNaN(normThumbHeight / normThumbWidth * psmSize.showcaseWidth)
      const diffThumbHeight = psmSize.showcaseHeight - overThumbHeight
      const marginTop = Math.ceil(diffThumbHeight / 2)
      setCss(thumbElm, 'width', psmSize.showcaseWidth)
      setCss(thumbElm, 'height', 'auto')
      setCss(thumbElm, 'marginTop', marginTop)
      setCss(thumbElm, 'marginLeft', null)
    }
  }

  function thumbLoadDoneCallback(imgSize) {

    thumbSize = imgSize

    const optionalApplyShowcaseSize = thumbFit
      ? noop
      : applyShowcaseSize

    $ctrl.ggsContentDoneCallback(
      calcContentWidth,
      calcContentHeight,
      optionalApplyShowcaseSize)

    const veryWide = (zeroIfNaN(thumbSize.width / thumbSize.height) > 2) && $ctrl.ggsProperties.carousel_mode
    const veryLong = (zeroIfNaN(thumbSize.height / thumbSize.width) > 2) && !$ctrl.ggsProperties.carousel_mode
    const veryLarge = veryWide || veryLong

    const tryReplaceWithRaw = true
      && !thumbRaw
      && veryLarge
      && $ctrl.ggsPost.preview.info.isSomeImage

    if (tryReplaceWithRaw) {
      imgQueue.stayInQueue($ctrl.ggsPost.preview.file).then(
        replaceWithRawSuccess,
        replaceWithRawProblem)
    }
  }

  function thumbLoadFailCallback() {
    $ctrl.ggsContentFailCallback()
  }

  function replaceWithRawSuccess() {
    thumbElm.src = $ctrl.ggsPost.preview.file
  }

  function replaceWithRawProblem(err) {
    $log.warn(`${sign}#replaceWithRawProblem: thumb will not be replaced with raw image because of`, err)
  }
}
